export default __webpack_public_path__ + "static/media/fc_sale_bottom_banner.aa1253d7.png";